import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { pixels } from 'site-modules/shared/utils/loading-utils';

import './loading-shimmer.scss';

export function LoadingShimmer({ className = '', size = 20 }) {
  return <div className={classNames('loading-wrapper w-100', className)} style={{ height: pixels(size) }} />;
}

LoadingShimmer.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
